import type { DerivedState } from '../derivedState.ts';

import type {
	ConfluenceContentShareRecipient,
	ConfluenceRecipientType,
} from './__generated__/useShareToPrincipalsShareContentMutation.graphql.ts';

export type NotificationRecipient = {
	type: string;
	id?: string;
	email?: string;
};

/**
 * Generates a list of notification recipients based on the current staged recipients
 */
export function getNotificationRecipients({
	stagedNotificationRecipients,
}: {
	stagedNotificationRecipients: DerivedState['stagedNotificationRecipients'];
}): NotificationRecipient[] {
	const notificationRecipients: NotificationRecipient[] = [];

	addRecipientsToList(notificationRecipients, stagedNotificationRecipients);

	return notificationRecipients;
}

function addRecipientsToList(
	list: NotificationRecipient[],
	recipients: DerivedState['stagedNotificationRecipients'],
) {
	recipients.forEach((recipient) => {
		if (recipient.type === 'email') {
			list.push({
				email: recipient.id,
				type: 'user',
			});
		} else if (recipient.type === 'external_user') {
			list.push({
				email: recipient.email,
				type: 'user',
			});
		} else {
			list.push({
				id: recipient.id,
				type: recipient.type,
			});
		}
	});
}

export const transformNotificationRecipients = (
	recipients: NotificationRecipient[],
): ConfluenceContentShareRecipient[] => {
	return recipients.map((recipient) => {
		let recipientType: ConfluenceRecipientType;
		switch (recipient.type) {
			case 'user':
				recipientType = 'USER';
				break;
			case 'group':
				recipientType = 'GROUP';
				break;
			case 'team':
				recipientType = 'TEAM';
				break;
			default:
				throw new Error(`Unknown recipient type: ${recipient.type}`);
		}

		return {
			id: recipient.id,
			email: recipient.email,
			recipientType,
		};
	});
};
